const AUTH_STORAGE_KEY = 'wallLabsAuthSession'

export function saveAuthSession(authResult, username = '') {
  if (!authResult) return

  const expiresInSeconds = Number(authResult.ExpiresIn) || 3600
  const expiresAt = Date.now() + expiresInSeconds * 1000

  localStorage.setItem(
    AUTH_STORAGE_KEY,
    JSON.stringify({
      username: String(username || '').trim(),
      expiresAt,
      idToken: authResult.IdToken || '',
      accessToken: authResult.AccessToken || '',
      refreshToken: authResult.RefreshToken || ''
    })
  )
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_STORAGE_KEY)
}

export function getAuthSession() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    clearAuthSession()
    return null
  }
}

export function isAuthenticated() {
  const session = getAuthSession()
  if (!session) return false

  if (!session.accessToken && !session.idToken) {
    clearAuthSession()
    return false
  }

  if (session.expiresAt && Date.now() >= session.expiresAt) {
    clearAuthSession()
    return false
  }

  return true
}
